import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/fonts.css';
import { Container, Row, Col } from 'react-bootstrap';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Header } from './components/Header'
import SidebarAccount from './components/SidebarAccount'
import { Home } from './Pages/Home'
import { Register } from './Pages/Register'
import { ChangePassword } from './Pages/ChangePassword'
import { ResetPassword } from './Pages/ResetPassword'
import { MyAccount } from './Pages/MyAccount'
import { Download } from './Pages/Download'
import { Banner } from './components/Banner';
import { Footer } from './components/Footer';
import { NavigationBar } from './components/NavigationBar';
import { AccountProvider } from './Context/AccountProvider';
import { LayoutProvider, useLayout } from './Context/LayoutProvider';
import { PrivateRoute } from './components/PrivateRoute';
import { StaffRoute } from './components/StaffRoute';
import { CreatorRoute } from './components/CreatorRoute';
import { Guide } from './Pages/Guide';
import { Rules } from './Pages/Rules';
import { FrequentlyAskedQuestions } from './Pages/FrequentlyAskedQuestions';
import { EventSchedule } from './Pages/EventSchedule';
import { TicketPage } from './Pages/TicketPage';
import { TicketView } from './Pages/TicketView';
import { CreateTicket } from './Pages/CreateTicket'
import { StaffTicketPage } from './Pages/StaffTicketPage';
import { UsefulLinks } from './components/UsefulLinks';
import { FacebookWidget } from './components/FacebookWidget';
import { UpdateNotes } from './components/UpdateNotes';
import { NobilityReset } from './components/NobilityReset';
import { TermsOfService } from './Pages/TermsOfService';
import { PrivacyPolicy } from './Pages/PrivacyPolicy';
import { RefundPolicy } from './Pages/RefundPolicy';
import { Updates } from './Pages/Updates';
import { StaffSettingsPage } from './Pages/StaffSettingsPage';
import { PaymentLogs } from './Pages/PaymentLogs';
import { DonationStorePreview } from './Pages/DonationStorePreview';
import { StoreItemDetails } from './Pages/StoreItemDetails'
import { StaffAnnouncementManagement } from './Pages/StaffAnnouncementManagement';
import { StaffEventSchedule } from './Pages/StaffEventSchedule';
import { StaffCreatorManagement } from './Pages/StaffCreatorManagement';
import { StaffPackageManagement } from './Pages/StaffPackageManagement';
import { StaffGuideManagement } from './Pages/StaffGuideManagement';
import { StaffLogViewer } from './Pages/StaffLogViewer';
import { StaffPanel } from './Pages/StaffPanel';
import { CreatorDashboard } from './Pages/CreatorDashboard';
import { BuyCoins } from './Pages/BuyCoins';
import { GuideDev } from './Pages/GuideDev';

function AppLayout() {
  const { fullWidth } = useLayout();

  return (
    <Router>
      <NavigationBar/>

      <Header/>

      <Container className="main-content">
        <Row className="upper-container justify-content-md-center">
          <Col xs="12" lg="3" className={`main-left order-2 order-lg-1${fullWidth ? ' hide' : ''}`} id="sidebarColumn">
            <SidebarAccount />
            <UsefulLinks />
            <UpdateNotes />
            <NobilityReset />
            <FacebookWidget />
          </Col>
          <Col xs="12" lg={fullWidth ? "12" : "8"} className="main-right order-1 order-lg-2" id="contentColumn">
            <Banner />
            <div id="main-content" className="main-container">
              <Switch>
                {/* Public routes */}
                <Route path="/register" component={Register} />
                <Route path="/download" component={Download} />
                <Route path="/rules" component={Rules} />
                <Route path="/guide" component={Guide} />
                <Route path="/guidedev" component={GuideDev} />
                <Route path="/eventschedule" component={EventSchedule} />
                <Route path="/resetpassword" component={ResetPassword} />
                <Route path="/faq" component={FrequentlyAskedQuestions} />
                <Route path="/tos" component={TermsOfService} />
                <Route path="/privacy" component={PrivacyPolicy} />
                <Route path="/refundpolicy" component={RefundPolicy} />
                <Route path="/store/:id" component={StoreItemDetails} />
                <Route path="/store" component={DonationStorePreview} />
                <Route path="/updates/:id" component={Updates} />
                <Route path="/updates/" component={Updates} />

                {/* Authenticated routes */}
                <PrivateRoute path="/myaccount" component={MyAccount} />
                <PrivateRoute path="/changepassword" component={ChangePassword} />
                <PrivateRoute path="/buycoins" component={BuyCoins} />
                <PrivateRoute path="/buycoinstebex" component={BuyCoins} />
                <PrivateRoute path="/purchasehistory" component={PaymentLogs} />
                <PrivateRoute path="/createticket" component={CreateTicket} />
                <PrivateRoute path="/tickets" component={TicketPage} />
                <PrivateRoute path="/ticket/:id" component={TicketView} />

                {/* Creator route */}
                <CreatorRoute path="/creator" component={CreatorDashboard} />

                {/* Staff-only routes */}
                <StaffRoute exact path="/staff" component={StaffPanel} />
                <StaffRoute path="/staff/events" component={StaffEventSchedule} />
                <StaffRoute path="/staff/announcements" component={StaffAnnouncementManagement} />
                <StaffRoute path="/staff/tickets" component={StaffTicketPage} />
                <StaffRoute path="/staff/settings" component={StaffSettingsPage} />
                <StaffRoute path="/staff/creators" component={StaffCreatorManagement} />
                <StaffRoute path="/staff/packages" component={StaffPackageManagement} />
                <StaffRoute path="/staff/guides" component={StaffGuideManagement} />
                {process.env.REACT_APP_ENABLE_STAFF_LOGS === 'true' && (
                  <StaffRoute path="/staff/logs" component={StaffLogViewer} />
                )}

                <Route path="/" component={Home} />
              </Switch>
            </div>
          </Col>
        </Row>
        <Row className="footer-container">
          <Col>
            <Footer/>
          </Col>
        </Row>
      </Container>
    </Router>
  );
}

function App() {
  return (
    <AccountProvider>
      <LayoutProvider>
        <AppLayout />
      </LayoutProvider>
    </AccountProvider>
  );
}

export default App;
